import React from 'react';
import { useQuizContext } from '../../../../context/QuizContext';
import AnswerChoice from '../../AnswerChoice';
import { P } from '@osmosis/react-ui/components/Text';
import { GraphicData } from '../../../../types/quiz';
import { QuizContainer } from '../../QuizContainer';

/**
 * Https://elsevier.atlassian.net/browse/OSMS-2006.
 */
const Graphic = () => {
  const { currentItem } = useQuizContext();
  return (
    <QuizContainer>
      <P
        fontSize={16}
        color="gray50"
        fontWeight={400}
        textAlign="justify"
        dangerouslySetInnerHTML={{
          __html: (currentItem?.data as GraphicData).question,
        }}
      />

      <AnswerChoice />
    </QuizContainer>
  );
};

export default Graphic;
